import { render, staticRenderFns } from "./ResultListGuanfang.vue?vue&type=template&id=18f48862&scoped=true&"
import script from "./ResultListGuanfang.vue?vue&type=script&lang=js&"
export * from "./ResultListGuanfang.vue?vue&type=script&lang=js&"
import style0 from "./ResultListGuanfang.vue?vue&type=style&index=0&id=18f48862&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f48862",
  null
  
)

export default component.exports